import { useState } from 'react';

import { LookupAutocompleteView } from '@/shared/ui/molecules/LookupAutocomplete';

import { useCompanySearchDropdown } from '../../../hooks/useCompanySearchDropdown';

import type { LookupAutocompleteProps } from './StudentAutocomplete';

/** Props de `CompanyAutocomplete`. */
export interface CompanyAutocompleteProps extends LookupAutocompleteProps {
  readonly hasError?: boolean | undefined;
  /** Camada da lista de opções — necessário quando o campo vive dentro de um modal. */
  readonly optionListClassName?: string | undefined;
}

/** Autocomplete de empresa (lookup `person/shared/associated-companies`). */
export function CompanyAutocomplete({
  value,
  selectedLabel,
  onChange,
  label,
  placeholder,
  hasError,
  optionListClassName,
}: CompanyAutocompleteProps) {
  const [search, setSearch] = useState('');
  const { options, isQuerySuccess } = useCompanySearchDropdown(search);

  return (
    <LookupAutocompleteView
      label={label}
      placeholder={placeholder}
      value={value}
      selectedLabel={selectedLabel}
      options={options}
      isQuerySuccess={isQuerySuccess}
      hasError={hasError === true}
      {...(optionListClassName === undefined ? {} : { optionListClassName })}
      search={search}
      onSearchChange={setSearch}
      onSelect={(id, itemLabel) => {
        onChange(id, itemLabel);
        setSearch('');
      }}
      onClear={() => {
        onChange('', '');
        setSearch('');
      }}
    />
  );
}
